import React, { useState, useEffect, useCallback } from 'react';
import ListItem from 'components/controls/ListItem/ListItem';
import { EntityComplaint } from 'types/EntityComplaint';
import { ActiveComponentEnum as ActiveComponentType } from 'enums/enums';
import { ComplaintListProps } from 'types/ListAndDetailTypes';
import ListWithLogo from '../ListWithLogo/ListWithLogo';
import Card from 'components/Card/Card';
import DropDown from '../DropDown/DropDown';
import { useAppSelector } from '../../../redux/hooks';
import useApi from 'hooks/useApi';
import WithApi from 'components/ui/WithApi/WithApi';
import { Option } from 'types/DropDown';

const ComplaintList: React.FC<ComplaintListProps> = ({ fetchData, fetchDetails, headerText, subheaderText = '', isShowDetails,
    options, title, placeholder, showIcon = true, isShowTextInIcon = true, isComparedOnYear = false }) => {
    const [activeComponent, setActiveComponent] = useState(ActiveComponentType.List);
    const [selectedComplaint, setSelectedComplaint] = useState<EntityComplaint | null>(null);
    const [selectedOption, setSelectedOption] = useState<Option | null>(null);
    const { period } = useAppSelector((state) => state.general);

    const { callApi, data, loading, error } = useApi<EntityComplaint[]>(fetchData);

    useEffect(() => {
        fetchDataForOption();
        setActiveComponent(ActiveComponentType.List);
        setSelectedOption(null);
    }, [period]);

    useEffect(() => {
        if (activeComponent === ActiveComponentType.List) {
            fetchDataForOption();
        }
    }, [activeComponent]);

    const fetchDataForOption = (optionId?: string) => {
        callApi(optionId);
    }

    const handleNavigation = (componentName: ActiveComponentType, complaintEntity: EntityComplaint | null = null) => {
        setActiveComponent(componentName);
        setSelectedComplaint(complaintEntity);
    };

    const handleSelectOption = async (optionId?: string) => {
        const resolvedOptions = await options();
        const selected = resolvedOptions.find(option => option.id === optionId);
        setSelectedOption(selected || null);
        fetchDataForOption(optionId);
    };

    return (
        <div className={`h-100 cardList `}>
            {activeComponent === ActiveComponentType.List && (
                <Card header={headerText} subHeader={subheaderText} components={[
                    <DropDown
                        options={options}
                        title={title}
                        placeholder={placeholder}
                        onSelect={handleSelectOption}
                    />,
                    <WithApi data={data} loading={loading} error={error}>
                        <ListWithLogo showIcon={showIcon} complaints={data} onNavigate={handleNavigation} />
                    </WithApi>
                ]} />
            )}
            {activeComponent === ActiveComponentType.EntityDetails && selectedComplaint && (
                <Card components={[
                    <ListItem
                        onNavigate={handleNavigation}
                        complaint={selectedComplaint}
                        fetchDetails={fetchDetails}
                        isShowDetails={isShowDetails}
                        isFullSubHeader={true}
                        isShowTextInIcon={isShowTextInIcon}
                        isComparedOnYear={isComparedOnYear}
                    />
                ]} />
            )}
        </div>
    );
};

export default ComplaintList;
